<template>
  <div id="contact">
    <div class="container">
      <div class="row">
        <div class="col-lg-9">
          <div class="blogs_list_box" v-for="(item,index) in list" :key="index" @click="goDetail(item.id)">
            <div class="title">
              {{item.title}}
            </div>
            <div class="img_box">
              <img :src="item.cover" alt="">
            </div>
            <div class="info_box" v-html="item.contents">

            </div>
            <div class="more_box" >{{$t("readMore")}}</div>
          </div>
          <div style="line-height: 300px;text-align: center" v-if="list.length<1">No.blog</div>

        </div>
        <div class="col-lg-3">
          <div class="query_box">
            <input type="text" placeholder="Buscar" v-model="keyword">
            <div class="right_btn" @click="getList(id)">Buscar</div>
          </div>
          <div class="classify_box">
            <div class="title_box">{{ $t("CATEGORAS") }}</div>
            <div class="classify_list_box" v-for="(item,index) in classList" :key="index"  @click="getList(item.id)">
              <div class="left"></div>
              <div class="right">{{ item.className }}（{{ item.blogNum }}）</div>
            </div>

          </div>
          <div class="classify_box" style="margin-top: 40px">
            <div class="title_box">{{ $t("readMore1") }}</div>
            <div class="goods_list_box" v-for="(item,index) in oldList" :key="index"  @click="goDetail(item.id)">
              <div class="left">
                <img :src="item.cover" alt="">
              </div>
              <div class="right">
                {{item.title}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getBlogClassList } from '@/api';
import {getGlogListt,getOldLists} from "../../api";

export default {
  data() {
    return {
      classList:[],
      list:[],
      oldList:[],
      keyword:'',
      id:''
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getData()
    this.getOldList()
    this.getList(this.$route.query.id)
  },
  computed: {

  },
  watch: {
  },
  methods: {
    getData(){
      let params = {
        // skuId: this.skus.skuId,
        // num: this.quantity
      }
      getBlogClassList(params).then(res => {
        this.classList = res.data.data;
        console.log('-------',res.data.data)
      })
    },
    getList(id){
      let params = {
        class_id: id,
        keyword: this.keyword
      }
      getGlogListt(params).then(res => {
        this.list = res.data.data.list;
      })
    },
    goDetail(id){
      this.$router.push({path:'/blogsDtail',query: {id:id}})
    },
    getOldList(){
      getOldLists({}).then(res => {
        this.oldList = res.data.data
        console.log('==', res)
      })
    },

  }
}
</script>
<style scoped lang="less">
.container{
  max-width: 1200px;
  padding-top: 20px;
}
.blogs_list_box{
  padding: 0 80px 80px 80px;
  .title{
    font-size: 22px;
    line-height: 28px;
    font-weight: 500;
  }
  .img_box{
    width: 100%;
    margin-top: 30px;
    img{
      width: 100%;
      max-height: 400px;
      object-fit: cover;
    }
  }
  .info_box{
    line-height: 28px;
    margin-top: 30px;
    font-size: 14px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  .more_box{
    text-align: right;
    margin-top: 30px;
    cursor: pointer;
    color: red;
  }
}
.classify_box{
  padding-right: 20px;
  .title_box{
    font-size: 18px;
    height: 36px;
    border-bottom: 1px solid #999999;
  }
  .classify_list_box{
    height: 40px;
    line-height: 40px;
    /*margin-top: 6px;*/
    .left{
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #999999;
      float: left;
      margin-top: 17px;
    }
    .right{
      float: left;
      margin-left: 12px;
      font-size: 16px;
      /*color: #999999;*/
      cursor: pointer;
    }
  }
  .goods_list_box{
    clear: both;
    padding-top: 20px;
    .left{
      float: left;
      width: 80px;
      height: 60px;
      img{
        width: 80px;
        height: 60px;
        object-fit: cover;
      }
    }
    .right{
      float: left;
      font-size: 14px;
      margin-left: 8px;
      max-width: 180px;
      line-height: 18px;
      height: 36px;
      overflow: hidden;
    }
  }
}
.query_box{
  width: 250px;
  border: 1px solid #999999;
  height: 36px;
  margin-bottom: 30px;
  input{
    height: 30px;
    margin-top: 2px;
    margin-left: 4px;
    border: 0;
    outline: none;
  }
  .right_btn{
    width: 60px;
    float:right;
    height: 34px;
    background: #2270F8;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
    line-height: 34px;
    cursor: pointer;
  }
}
</style>
